module.exports = __webpack_public_path__ + "img/no-notification.e4e32a10.png";